<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Usuários</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>											
					</template>					
				</Toolbar>

				<DataTable :value="usuarios" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="nomeLogin" header="Login" sortable></Column>
					<Column field="email" header="E-mail" sortable></Column>
					<Column field="perfil" header="Perfil" sortable></Column>	
					<Column field="dataUltimoAcesso" header="Último acesso" sortable>
						<template #body="slotProps">
                            {{ formatarStringDataHora(slotProps.data.dataUltimoAcesso) }}
                        </template>
					</Column>	
					<Column field="dataCadastro" header="Cadastro" sortable>
						<template #body="slotProps">
                            {{ formatarStringDataHora(slotProps.data.dataCadastro) }}
                        </template>
					</Column>								
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
                            <Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogCadastro" header="Novo Usuário" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-12">
                            <label for="nome">Nome</label>
                            <InputText id="nome" v-model="usuario.nome" required="true" autocomplete="off" />
                            <small class="p-invalid" v-if="enviandoForm && !usuario.nome">Informe o nome</small>
                        </div>                       
                    </div>
					<div class="p-fluid p-formgrid p-grid">                    
                        <div class="p-field p-col-12 p-md-12">
                            <label for="email">E-mail</label>
                            <InputText id="email" v-model.trim="usuario.email" autocomplete="off"/>
                            <small class="p-invalid" v-if="enviandoForm && !usuario.email">Informe o e-mail</small>
                        </div>                  
                    </div>
					<div class="p-fluid p-formgrid p-grid">                       
                        <div class="p-field p-col-12 p-md-12">
                            <label>Perfil</label>
                            <Dropdown v-model="idPerfilSelecionado" :options="perfis" optionLabel="nome" optionValue="id" appendTo="body"/>                         
                        </div> 
                    </div>				
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir usuário <b>{{ usuarioSelecionado.nome }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>
</template>

<script>
import UsuarioService from '@/service/UsuarioService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	usuarioService: null,
	data() {
		return {	
			exibirDialogConfirmarExcluir: false,
			idPerfilSelecionado: null,
			permissaoNovo: false,
			permissaoEditar: false,		
			permissaoExcluir: false,	
			exibirDialogCadastro: false,		
			enviandoForm: false,
			usuario: {nome: '', email: ''},
			perfis: [],
			usuarios: [],		
			usuarioSelecionado: {},
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),	
		listar(){
			this.usuarioService.listar({...this.getDadosRequisicao()})
				.then(resp => {			
					this.usuarios = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },	
        novo() {
			this.usuarioService.listarPerfis({...this.getDadosRequisicao()})
				.then(resp => {			
					this.perfis = resp.data;
                    if(this.perfis.length > 0) {
                        this.idPerfilSelecionado = this.perfis[0].id;
                    }
					this.usuario = {nome: '', email: ''};
					this.exibirDialogCadastro = true;
					this.enviandoForm = false;
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		salvar() {
			this.enviandoForm = true;
			if(this.usuario.nome != '' && this.usuario.email != '') {
				let perfil = {id: this.idPerfilSelecionado};
				let requisicao = {
					usuario: {...this.usuario},
					perfil: perfil,
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.usuarioService.salvar(requisicao)
					.then(resp => {	
						this.fecharModal();
						this.listar();
						exibirMensagem(this, resp);						
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}
		},
		excluir() {
			let usuario = {id: this.usuarioSelecionado.id, nome: this.usuarioSelecionado.nome};
			let requisicao = {
				usuario: usuario,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.usuarioService.excluir(requisicao)
				.then(resp => {
					exibirMensagem(this, resp);	
					this.limparExcluir();		
					this.listar();		
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		editar(usuario) {
			this.$router.push('/sistema/usuarios/'+usuario.id+'/editar');
		},
		confirmarExcluir(usuario) {
			this.usuarioSelecionado = usuario;
			this.exibirDialogConfirmarExcluir = true;
		},
		limparExcluir() {
			this.usuarioSelecionado = {};
			this.exibirDialogConfirmarExcluir = false;
		},
		fecharModal() {
			this.usuario = {nome: '', email: ''};
			this.exibirDialogCadastro = false;
			this.enviandoForm = false;
		},
		formatarStringDataHora(data) {
			if(!data) {
				return '';
			}
            let dataHora = data.split(' ');
			let partes = dataHora[0].split('-');
			return partes[2] + '/' + partes[1] + '/' + partes[0] + ' ' + dataHora[1];
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(3);
            this.permissaoEditar = permissoes.includes(4);	
            this.permissaoExcluir = permissoes.includes(5);				
		}
	},	
	created() {
		this.usuarioService = new UsuarioService();			
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();		
	}
}
</script>

<style scoped>
</style>